import { concatRegexp, formatPrice } from './quantity-price';
import { $Q } from './query-selector';

/**
* Calls the functions:
* {} To capture the variants.
* {} Makes the modification of the amounts
* @param {object} parent Parent element of the container.
* @param {number} qty quantity in the input element.
*/
function calculeResiduary(limit, total) {
  const newprice = (limit - formatPrice(total)).toFixed(2);
  return concatRegexp(total, newprice);
}

/**
 * Update the width of bar progress
 * @param {HTMLElement} input - input hidde with data
 */
export const barProgress = (input, parent = null) => {
  if (!input) return;
  const progress = $Q('.bar-progress', parent);
  const elementTotal = $Q('.total-residuary', parent);
  const textProgress = $Q('.progress-text-js', parent);
  const textFreeShipping = $Q('.shipping-free', parent);
  const { dataset: { total, totalFormat, limit } } = input;
  const totalPrice = parseFloat(total) / 100;

  const barWidth = (totalPrice / limit) * 100;
  const residuaryPrice = calculeResiduary(limit, totalFormat);

  if (barWidth > 100) {
    progress.style.width = '100%';
    textProgress.style.display = 'none';
    textFreeShipping.style.display = 'block';
  } else {
    progress.style.width = `${barWidth}%`;
    elementTotal.innerHTML = residuaryPrice;
    textProgress.style.display = 'block';
    textFreeShipping.style.display = 'none';
  }
};
